function updateTimelineLine(timelineEl, eventRowClass, dotClass) {
  if (!timelineEl) return;
  const rows = Array.from(timelineEl.querySelectorAll(`.${eventRowClass}`));
  const visibleRows = rows.filter(row => row.offsetParent !== null);
  const firstRow = visibleRows[0];
  const lastRow = visibleRows[visibleRows.length - 1];

  if (firstRow && lastRow) {
    const firstDot = firstRow.querySelector(`.${dotClass}`);
    const lastDot = lastRow.querySelector(`.${dotClass}`);
    if (firstDot && lastDot) {
      const timelineRect = timelineEl.getBoundingClientRect();
      const firstDotRect = firstDot.getBoundingClientRect();
      const lastDotRect = lastDot.getBoundingClientRect();
      const startY = firstDotRect.top - timelineRect.top + (firstDotRect.height / 2);
      const endY = lastDotRect.top - timelineRect.top + (lastDotRect.height / 2);
      const height = endY - startY;
      timelineEl.style.setProperty('--timeline-top', `${startY}px`);
      timelineEl.style.setProperty('--timeline-height', `${height}px`);
    }
  }
}

export default updateTimelineLine;
